import http from '../utils/http';
import {
  ADD_JOB,
} from '../constants/actionTypes';

import { setFeedbackAction } from './feedback';

import {
  jobsUrl
} from '../constants/urls';

import {
  setFormSubmitting,
} from './form';

const addJobAction = jobId => ({ type: ADD_JOB, payload: jobId });

export const addJob = job =>
  async dispatch => {
    try {
      dispatch(setFormSubmitting(true))
      const { data: response } = await http.post(jobsUrl, job);

      dispatch(addJobAction(response.data.id));
      dispatch(setFormSubmitting(false))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
      dispatch(setFormSubmitting(false))
    }
  }



// WEBPACK FOOTER //
// ./src/actions/addJob.js